var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.13589 1.48359C6.52162 0.821322 7.47838 0.821321 7.86411 1.48359L9.36447 4.05954C9.50577 4.30214 9.74255 4.47417 10.0169 4.53359L12.9304 5.1645C13.6795 5.3267 13.9752 6.23663 13.4645 6.80814L11.4783 9.03107C11.2912 9.24043 11.2008 9.51877 11.229 9.7981L11.5293 12.764C11.6065 13.5265 10.8325 14.0889 10.1312 13.7798L7.40325 12.5777C7.14634 12.4645 6.85366 12.4645 6.59675 12.5777L3.86883 13.7798C3.16749 14.0889 2.39346 13.5265 2.47067 12.764L2.77096 9.7981C2.79924 9.51878 2.7088 9.24043 2.52174 9.03107L0.5355 6.80814C0.0248449 6.23663 0.320497 5.3267 1.06955 5.1645L3.98306 4.53359C4.25745 4.47417 4.49423 4.30214 4.63553 4.05954L6.13589 1.48359Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.7fcbdc4c.svg";
export { ForwardRef as ReactComponent };var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.13589 1.48359C6.52162 0.821322 7.47838 0.821321 7.86411 1.48359L9.36447 4.05954C9.50577 4.30214 9.74255 4.47417 10.0169 4.53359L12.9304 5.1645C13.6795 5.3267 13.9752 6.23663 13.4645 6.80814L11.4783 9.03107C11.2912 9.24043 11.2008 9.51877 11.229 9.7981L11.5293 12.764C11.6065 13.5265 10.8325 14.0889 10.1312 13.7798L7.40325 12.5777C7.14634 12.4645 6.85366 12.4645 6.59675 12.5777L3.86883 13.7798C3.16749 14.0889 2.39346 13.5265 2.47067 12.764L2.77096 9.7981C2.79924 9.51878 2.7088 9.24043 2.52174 9.03107L0.5355 6.80814C0.0248449 6.23663 0.320497 5.3267 1.06955 5.1645L3.98306 4.53359C4.25745 4.47417 4.49423 4.30214 4.63553 4.05954L6.13589 1.48359Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.7fcbdc4c.svg";
export { ForwardRef as ReactComponent };